import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    articles: [],
    article: {},
  },
  getters: {
    articles: (state: any) => {
      return state.articles;
    },
  },
  mutations: {
    SET_ARTICLE(state: any, article: any) {
      state.article = article;

      state.article.lists = [];
      if (
        article.listItemsByArticleId &&
        article.listItemsByArticleId.nodes.length > 0
      ) {
        state.article.lists = article.listItemsByArticleId.nodes.map(
          (listItem: any) => {
            return listItem.listByListId;
          },
        );
      }

      if (article.knowledgeAssociationsByArticleId) {
        article.knowledges = {
          formative: [],
        };
        article.knowledgeAssociationsByArticleId.nodes.map(
          (knowledgeAssociation: any) => {
            if (knowledgeAssociation.formative) {
              article.knowledges.formative.push(
                knowledgeAssociation.knowledgeByKnowledgeId,
              );
            }
          },
        );
      }

      state.article.user = article.userByUserId;
    },

    SET_EMPTY_ARTICLE(state: any, mutations: any) {
      let article = {
        id: null,
        title: null,
        content: [
          {
            content: '',
            behavior: 'text',
          },
        ],
        group: null,
      };
      state.article = article;
    },

    SET_ARTICLES(state: any, articles: any[]) {
      state.articles = articles.map((article: any) => {
        if (article.content && typeof article.content == 'string') {
          article.content = article.content;
        }
        return article;
      });
    },

    REMOVE_ARTICLE(state: any, index: number) {
      state.articles.splice(index, 1);
    },
  },
  actions: {
    async PULL_ARTICLE(
      { commit, state, rootState, getters }: any,
      articleId: number,
    ) {
      const userId = rootState.auth.user.id;
      const response = await query(
        `query PullArticle($articleId: Int!) {
          articleById(id: $articleId) {
            id
            title
            content
            group
            listItemsByArticleId{
              totalCount
              nodes {
                listByListId {
                  id
                  name
                }
              }
            }
            knowledgeAssociationsByArticleId{
              nodes{
                formative
                knowledgeByKnowledgeId {
                  id
                  name
                }
              }
            }
            userByUserId {
              name
            }
          }
        }`,
        {
          articleId: +articleId,
        },
      );
      let article = response.data.articleById;
      if (article != null) {
        commit('SET_ARTICLE', response.data.articleById);
      } else {
        commit('SET_EMPTY_ARTICLE');
      }
    },

    async PULL_ARTICLES_BY_TREE_KNOWLEDGES(
      { commit }: any,
      knowledges: Array<any>,
    ) {
      const response = await query(`
        query pullArticlesByTreeKnowledge{
          getSublevelArticleAssociations(
            parentPaths: [
              ${knowledges.map(elem => `"${elem.nodePath}"`)}
            ]
          ){
            nodes{
              id
              title
              content
              listItemsByArticleId{
                totalCount
              }
            }
          }
        }
      `);
      commit(
        'SET_ARTICLES',
        response.data.getSublevelArticleAssociations.nodes,
      );
    },

    async PUSH_ARTICLE(
      { commit, state, rootState, getters }: any,
      article: any,
    ) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;
      let response;
      let articleResponse;
      if (article.id != null) {
        response = await mutation(
          `mutation updateArticle ($articleId: Int!, $title: String!, $content: JSON, $group: String) {
            updateArticleById(
              input: {
                id: $articleId,
                articlePatch:{
                  title: $title,
                  content: $content,
                  group: $group
                }
              }
            ){
              article {
                id
                title
                content
                group
              }
            }
          }`,
          {
            articleId: article.id,
            title: article.title,
            content: article.content,
            group: article.group,
          },
        );
        articleResponse = response.data.updateArticleById.article;
      } else {
        response = await mutation(
          `mutation createArticle ($userId: Int!, $title: String!, $content: JSON, $group: String) {
            createArticle(
              input: {
                article: {
                  userId: $userId,
                  title: $title,
                  content: $content,
                  group: $group
                }
              }
            ) {
              article {
                id
                title
                content
                group
              }
            }
          }`,
          {
            userId: userId,
            title: article.title,
            content: article.content,
            group: article.group,
          },
        );
        articleResponse = response.data.createArticle.article;
      }
      //TODO error inputing Article

      if (articleResponse != null) {
        commit('SET_ARTICLE', articleResponse);
      }
    },

    async PULL_ARTICLES(
      { commit }: any,
      { currentPage, searchArticleContent }: any,
    ) {
      currentPage = currentPage || 0;
      searchArticleContent =
        searchArticleContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ||
        '';
      let resultsPerPage = 50;
      let offset = resultsPerPage * currentPage;
      let response;
      let articlesNodes;
      let articleInfo = `
        id
        title
        content
        listItemsByArticleId{
          totalCount
        }
      `;
      if (searchArticleContent.length === 0) {
        response = await query(
          `query getAllArticlesDexAdmin($resultsPerPage: Int, $offset: Int){
          allArticles(first: $resultsPerPage, offset: $offset, orderBy: ID_DESC) {
            nodes {
              ${articleInfo}
            }
          }
        }`,
          {
            resultsPerPage,
            offset,
          },
        );
        articlesNodes = response.data.allArticles;
      } else {
        response = await query(
          `query searchInArticles($resultsPerPage: Int, $offset: Int, $string: String) {
            searchInArticles(string: $string, first: $resultsPerPage, offset: $offset) {
              nodes {
                ${articleInfo}
              }
            }
          }
          `,
          {
            resultsPerPage,
            offset,
            string: searchArticleContent,
          },
        );
        articlesNodes = response.data.searchInArticles;
      }
      if (articlesNodes) {
        commit('SET_ARTICLES', articlesNodes.nodes);
      }
    },

    async REMOVE_ARTICLE({ commit }: any, articleId: number) {
      try {
        //Deleting the article
        let response = await mutation(
          `mutation deleteArticle($articleId: Int!) {
            deleteArticleById(input:{
              id: $articleId
            }) {
              article {
                id
              }
            }
          }`,
          {
            articleId: +articleId,
          },
        );
        return true;
        //TODO call the commit directly
      } catch (err) {
        return err;
      }
    },
  },
};
